/* global bottin */

let members = [];
let currentPage = 1;
const perPage = 60;

// ============================================
// SESSION STORAGE FUNCTIONS
// ============================================

/**
 * Save current search state to sessionStorage
 */
function saveSearchState() {
  try {
    const state = {
      firstname:
        document.querySelector('.member_firstname input')?.value.trim() || '',
      lastname:
        document.querySelector('.member_lastname input')?.value.trim() || '',
      cnb: document.querySelector('.member_cnb input')?.value.trim() || '',
      results: members,
      currentPage,
      lang: bottin.currentLang,
      timestamp: Date.now(),
    };

    sessionStorage.setItem('memberSearchState', JSON.stringify(state));
  } catch (error) {}
}

/**
 * Restore search state from sessionStorage
 */
function restoreSearchState() {
  try {
    const saved = sessionStorage.getItem('memberSearchState');
    if (!saved) return false;

    const state = JSON.parse(saved);

    // Only restore if saved within last hour (3600000 ms)
    if (Date.now() - state.timestamp > 3600000) {
      sessionStorage.removeItem('memberSearchState');
      return false;
    }

    // Restore form inputs
    const firstnameInput = document.querySelector('.member_firstname input');
    const lastnameInput = document.querySelector('.member_lastname input');
    const cnbInput = document.querySelector('.member_cnb input');

    if (firstnameInput) firstnameInput.value = state.firstname;
    if (lastnameInput) lastnameInput.value = state.lastname;
    if (cnbInput) cnbInput.value = state.cnb;

    // If the saved results are in a different language, re-fetch in the current language
    if (state.lang && state.lang !== bottin.currentLang) {
      const wrapper = document.getElementById('member_wrapper');
      if (wrapper) {
        wrapper.innerHTML = `<p class="bottin-loading">${bottin.loadingText}</p>`;
        document
          .querySelectorAll('.block-to-disappear')
          .forEach((b) => (b.style.display = 'none'));
        const bottomBlock = document.querySelector('.block-at-bottom');
        if (bottomBlock)
          bottomBlock.parentNode.insertBefore(wrapper, bottomBlock);
      }
      currentPage = state.currentPage || 1;
      const params = state.cnb
        ? { PermitNumber: state.cnb }
        : { prenom: state.firstname, nom: state.lastname };
      const url = `/wp-json/members/v2/get_members?${new URLSearchParams(
        params
      ).toString()}&lang=${bottin.currentLang}`;
      fetch(url)
        .then((r) => r.json())
        .then((result) => {
          members = Array.isArray(result.data) ? result.data : [];
          renderMembers();
          saveSearchState();
        })
        .catch(() => {});
      return true;
    }

    // Restore results and current page
    members = state.results || [];
    currentPage = state.currentPage || 1;

    // Re-render if we have results
    if (members.length > 0) {
      renderMembers();
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
}

/**
 * Clear saved search state
 */
function clearSearchState() {
  sessionStorage.removeItem('memberSearchState');
}

// ============================================
// RETRIEVE MEMBER LOGIC
// ============================================

(function checkGF() {
  if (typeof window.gform === 'undefined' || !window.gform.addAction) {
    return setTimeout(checkGF, 50);
  }

  window.gform.utils.addFilter(
    'gform/submission/pre_submission',
    async (formData) => {
      // Fetch prenom and nom directly from input fields in the DOM
      const prenom =
        document.querySelector('.member_firstname input')?.value || '';
      const nom = document.querySelector('.member_lastname input')?.value || '';

      const cnb = document.querySelector('.member_cnb input')?.value || '';

      // Use `data.abort = true;` to abort the submission if needed.
      formData.abort = true;

      try {
        // Add search params as query parameters
        const params = cnb ? { PermitNumber: cnb } : { prenom, nom };
        const query = new URLSearchParams(params).toString();
        const response = await fetch(
          `/wp-json/members/v2/get_members?${query}&lang=${bottin.currentLang}`
        );

        if (!response.ok) throw new Error('Network response was not ok');

        const result = await response.json();

        members = Array.isArray(result.data) ? result.data : [];
        currentPage = 1;

        renderMembers(members);

        // MODIFIED: Save search state after successful search
        saveSearchState();
      } catch (error) {
        throw new Error('Submission blocked, custom data rendered.');
      }
      return formData; // Allow submission if not blocked
    }
  );
})();

// Function to render Members
function renderMembers() {
  // Render results with wp.template
  const template = wp.template('member-card');
  const wrapper = document.getElementById('member_wrapper');
  const blocks = document.querySelectorAll('.block-to-disappear');
  const bottomBlock = document.querySelector('.block-at-bottom');

  wrapper.innerHTML = ''; // Clear old results

  if (members.length === 0) {
    wrapper.innerHTML = `<p>${bottin.noResultsText}</p>`;
  } else {
    // Pagination slice
    const start = (currentPage - 1) * perPage;
    const end = start + perPage;
    const paginated = members.slice(start, end);

    const topResultsInfo = document.createElement('div');
    topResultsInfo.classList.add('results-info');
    const topStart = (currentPage - 1) * perPage + 1;
    const topEnd = Math.min(currentPage * perPage, members.length);
    topResultsInfo.textContent = bottin.resultsText
      .replace('%1$d', topStart)
      .replace('%2$d', topEnd)
      .replace('%3$d', members.length);
    wrapper.appendChild(topResultsInfo);

    // Create grid container for the members
    const cityContainer = document.createElement('div');
    cityContainer.classList.add('city-container');

    // Render members inside the grid
    paginated.forEach((member) => {
      const html = template(member);
      const div = document.createElement('div');
      div.innerHTML = html;
      cityContainer.appendChild(div.firstElementChild);
    });

    // Add the container to the wrapper
    wrapper.appendChild(cityContainer);

    // Pagination Bar
    renderPagination(wrapper, members);
  }

  // After rendering all city sections, move wrapper before .block-at-bottom
  if (bottomBlock) {
    bottomBlock.parentNode.insertBefore(wrapper, bottomBlock);
  }

  blocks.forEach((block) => (block.style.display = 'none'));
}

// Function to render Pagination
function renderPagination(wrapper) {
  const totalResults = members.length;
  const totalPages = Math.ceil(totalResults / perPage);

  // Remove any previously rendered pagination (prevents duplicate listeners)
  const prevPagination = wrapper.querySelector('.pagination-bar');
  if (prevPagination) prevPagination.remove();

  if (totalPages <= 1) return; // no pagination needed

  const pagination = document.createElement('div');
  pagination.className = 'pagination-bar';

  // Left side: results info
  const resultsInfo = document.createElement('div');
  const start = (currentPage - 1) * perPage + 1;
  const end = Math.min(currentPage * perPage, totalResults);
  resultsInfo.classList.add('results-info');
  resultsInfo.textContent = bottin.resultsText
    .replace('%1$d', start)
    .replace('%2$d', end)
    .replace('%3$d', totalResults);
  pagination.appendChild(resultsInfo);

  // Right side: nav
  const nav = document.createElement('div');
  nav.className = 'pagination-nav';

  // Prev
  const prev = document.createElement('button');
  prev.className = 'prev';
  prev.disabled = currentPage === 1;
  prev.classList.toggle('disabled', currentPage === 1);
  prev.onclick = () => {
    if (currentPage > 1) {
      currentPage--;
      renderMembers(members);
      saveSearchState(); // ADDED: Save state when paginating
      const el = document.getElementById('member_wrapper');
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 210;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
  };
  prev.innerHTML = `<span class="icon-arrow" aria-hidden="true"></span>`;
  nav.appendChild(prev);

  // --- Ellipsis logic for pages ---
  const maxVisible = 2; // number of neighbors around current page

  function addPage(num) {
    const pageBtn = document.createElement('a');
    if (num === currentPage) pageBtn.classList.add('current');
    pageBtn.textContent = num;
    pageBtn.addEventListener('click', () => {
      currentPage = num;
      renderMembers(members);
      saveSearchState(); // ADDED: Save state when paginating
      const el = document.getElementById('member_wrapper');
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 210;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
    nav.appendChild(pageBtn);
  }

  function addEllipsis() {
    const ellipsis = document.createElement('span');
    ellipsis.textContent = '…';
    ellipsis.classList.add('ellipsis');
    nav.appendChild(ellipsis);
  }

  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 || // always show first
      i === totalPages || // always show last
      (i >= currentPage - maxVisible && i <= currentPage + maxVisible) // neighbors
    ) {
      addPage(i);
    } else if (
      i === 2 &&
      currentPage > maxVisible + 2 // left ellipsis
    ) {
      addEllipsis();
    } else if (
      i === totalPages - 1 &&
      currentPage < totalPages - maxVisible - 1 // right ellipsis
    ) {
      addEllipsis();
    }
  }

  // Next
  const next = document.createElement('button');
  next.className = 'next';
  next.disabled = currentPage === totalPages;
  next.classList.toggle('disabled', currentPage === totalPages);
  next.onclick = () => {
    if (currentPage < totalPages) {
      currentPage++;
      renderMembers(members);
      saveSearchState(); // ADDED: Save state when paginating
      const el = document.getElementById('member_wrapper');
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 210;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
  };
  next.innerHTML = `<span class="icon-arrow" aria-hidden="true"></span>`;
  nav.appendChild(next);

  pagination.appendChild(nav);
  wrapper.appendChild(pagination);
}

function updateSubmitButtonState() {
  const cnb = document.querySelector('.member_cnb input')?.value.trim() || '';
  const nom =
    document.querySelector('.member_lastname input')?.value.trim() || '';

  // Enable button only if at least one field is filled
  const isFormValid = cnb.length > 0 || nom.length >= 2;

  // Try multiple selectors for Gravity Forms submit buttons
  const submitButton =
    document.querySelector('.gform_button') ||
    document.querySelector('button[type="submit"]') ||
    document.querySelector('input[type="submit"]');

  if (submitButton) {
    submitButton.disabled = !isFormValid;
    submitButton.classList.toggle('disabled', !isFormValid);
  }
}

// Function to reset the form
document.addEventListener('DOMContentLoaded', () => {
  // MODIFIED: Restore search state on page load
  restoreSearchState();

  const resetBtn = document.getElementById('resetBtn');
  if (!resetBtn) return;

  resetBtn.addEventListener('click', function () {
    const form = this.form;
    form.reset();
    form.querySelectorAll('.gfield_label.active').forEach((label) => {
      label.classList.remove('active');
    });

    // Clear results + restore hidden blocks
    const wrapper = document.getElementById('member_wrapper');
    wrapper.innerHTML = '';
    document.querySelectorAll('.block-to-disappear').forEach((b) => {
      b.style.display = '';
    });

    // ADDED: Clear saved search state
    clearSearchState();

    // Reset submit button state
    updateSubmitButtonState();
  });

  // Initialize submit button state on page load
  updateSubmitButtonState();

  // Add event listeners to input fields
  const prenomInput = document.querySelector('.member_firstname input');
  const nomInput = document.querySelector('.member_lastname input');
  const cnbInput = document.querySelector('.member_cnb input');

  [prenomInput, nomInput, cnbInput].forEach((input) => {
    if (input) {
      input.addEventListener('input', updateSubmitButtonState);
      input.addEventListener('change', updateSubmitButtonState);
    }
  });

  // btn--accent clear is handled globally in main/clear-search-state.js
});
